import { r as T, c as b, h as e, F as l, H as A, g as M } from "./main-bb89b2f2.js";
import "vue";
const R = {
  COT: [
    "components-demand",
    "cage-damage",
    "carbon-fibre-reinforced-plastic",
    "common-rail-systems",
    "connected-components",
    "control-technology",
    "electric-machines",
    "electronics",
    "gateway",
    "gearboxes",
    "generator",
    "hydraulic-cylinders",
    "hydraulic-pumps-motors",
    "large-diameter-bearings",
    "measuring-device",
    "system-drive-technology",
    "winches",
    "components",
    "engine-production",
    "enginge-diagnostic",
    "hydraulic-power-unit",
    "piston-accumulator",
    "MDC3",
    "BCM-App",
    "excellence-components",
    "corrosion-damages",
    "frequency-inverter-cabinet",
    "reparatur",
    "general-overhaul",
    "exchange-components",
    "evaluation-old-part",
    "spray-hydraulic-cylinder",
    "liduro-power-port",
    "stroke-installation-length",
    "hydz-configurator",
    "electric-immobilizer",
    "automated-engine-shutdown",
    "weighing-system",
    "traceability",
    "einschubmotor",
    "pumpe-geschlossener-kreis",
    "pumpe-offener-kreis",
    "anbaumotor-variabel",
    "AxM",
    "zero-emission-combustion-engines",
    "paint-component",
    "segmented-large-diameter-bearings",
    "no-gateway",
    "system-expertise",
    "hardening",
    "liduro",
    "liduro-connect",
    "modular-system",
    "nameplate-service-compliance",
    "opal",
    "hydrostatic-swashplate-bearing",
    "COTC",
    "ESM"
  ],
  DS: [
    "digital-services-MyMaintenance-remote-support",
    "brandportal",
    "data-security",
    "online-marketing",
    "reliable",
    "shopping-cart",
    "webshop",
    "cloud",
    "licensing-software",
    "settings",
    "app-launcher",
    "my-jobsite",
    "cloud-1",
    "lh-web-platform",
    "data-exchange",
    "crane-finder",
    "user-permission",
    "user-logged",
    "user-log-in",
    "individualization",
    "aministrator",
    "crane-planner",
    "give-aways",
    "credit-card",
    "product-configurator",
    "identity-secured",
    "IP",
    "money-secured",
    "NFC-RFID",
    "lock-closed",
    "lock-open",
    "spare-parts-shipping",
    "digital-services-MyMaintenance",
    "content-delivery-portal",
    "filter",
    "digital-services-troubleshoot-advisor",
    "digital-services",
    "digital-services-MyAssets",
    "access-control",
    "system-usage",
    "bpm-basis",
    "electric-immobilizer",
    "myliebherr",
    "lidat",
    "4C-power",
    "mysuccess",
    "crane-configurator",
    "lisim",
    "litab",
    "partsXchanger",
    "lipos",
    "LiGO",
    "shared-services",
    "liAS",
    "AER-unlock",
    "myliebherr-application",
    "rfid",
    "xpert-assist",
    "digital-solutions",
    "towercrane-portal",
    "server",
    "too-many-requests",
    "server-error",
    "touch-display",
    "used-equipment-marketplace",
    "special-load-case",
    "LiTEL",
    "license-hardware",
    "master-data-costs",
    "master-data-area",
    "broadcast",
    "customer-systems",
    "data-interpretation",
    "API",
    "create-LCC",
    "pay-via-phone",
    "pay-via-terminal",
    "cloud-update",
    "artifical-intelligence",
    "wear-log-subgroup",
    "digital-table",
    "digital-project-portfolio",
    "wear-log",
    "administrator",
    "search-LCC",
    "application-portal",
    "intranet",
    "maintenance-repair-center",
    "password",
    "product-connect",
    "pmd-manager",
    "software-distribution",
    "centre-of-data-excellence",
    "ims",
    "locked",
    "software-upgrades",
    "supplier-evaluation-tool",
    "PDE",
    "add-on",
    "digitalization",
    "HNGRYnsite",
    "liconnect",
    "computer-aided-design",
    "data-view",
    "one-crm",
    "skyview",
    "tech-tuesday",
    "digital-service-booklet",
    "lios",
    "ip-management",
    "manufacturing-execution-system",
    "LAN",
    "LiSIM",
    "site-monitoring",
    "machine-park-manager",
    "remote-access",
    "LiReCon",
    "crm",
    "eam",
    "myliebherr-base",
    "translate",
    "foresight-management",
    "LHSHOP",
    "LHSHOPRETAILER"
  ],
  PL: [
    "stock",
    "caliper",
    "error-rework",
    "products",
    "quality",
    "service-menu",
    "tracking",
    "workwear",
    "speed",
    "transport-logistics",
    "weight",
    "angle-90-degrees",
    "battery",
    "breakdown",
    "engine-production",
    "robotics",
    "double-gearwheel",
    "filter-module-for-diesel-particles",
    "maternity-leave-process",
    "organization-chart",
    "connected-fab",
    "calibration",
    "Ecu",
    "faster",
    "export",
    "gear-damage",
    "over-production",
    "oversized-processes",
    "crane-planner",
    "joystick",
    "conical-flask",
    "electrolyzer",
    "goods-incoming",
    "goods-outgoing",
    "modern-workplace-production",
    "money-liquidity",
    "package",
    "productivity",
    "profitability",
    "wrench",
    "dashboard",
    "load-securing",
    "permantently-suppressed-DPF-regeneration",
    "production-workers",
    "company",
    "gearwheel",
    "innovation-pipeline",
    "24-7",
    "double-gearwheel-checked",
    "double-gearwheel-crossed",
    "varnishing",
    "weighing-system",
    "myOrganization",
    "partsXchanger",
    "statics-selector",
    "time-to-market",
    "service-component-production",
    "energy-relay-power-supply",
    "missing-measuring-equipment",
    "tyres",
    "10-5",
    "ERP-info",
    "high-pressure-buffer-storage",
    "liquid-storage",
    "safety-shoes",
    "certificate-of-competence",
    "high-voltage",
    "logistics",
    "machinery-and-plant-engineering",
    "max-speed",
    "propan",
    "end2end-process",
    "manufacturing-execution-system",
    "heatexchanger",
    "LAN",
    "stretchable",
    "innovation-management",
    "product-change-management",
    "LiSIM",
    "static-selector",
    "operational-conformance",
    "work-accident",
    "SAL-specification-list",
    "visitor-safety",
    "travel-conveyor",
    "assembly-bench",
    "simulator",
    "TPP"
  ],
  PE: [
    "invisible",
    "application",
    "contacts",
    "employees",
    "service-center",
    "onboarding",
    "user",
    "my-uploads",
    "LPS-supplier-portal",
    "service",
    "service-partner",
    "unused-employee-potential",
    "visible",
    "team",
    "active-sourcing",
    "booth",
    "brain",
    "brand-ambassador",
    "classes",
    "employee-events",
    "target-group",
    "job-interview",
    "visits-to-doctor-during-working-hours",
    "WDS-eldercare",
    "sport-1",
    "break-regulations-normal-workers",
    "break-regulations-shift-workers",
    "children-sick-pay",
    "sport-2",
    "sport-6",
    "sport-3",
    "sport-9",
    "sport-8",
    "sport-5",
    "sport-4",
    "sport-7",
    "user-permission",
    "family-business",
    "hand",
    "Hans-Liebherr-Hilfe-eV",
    "maternity-protection",
    "user-logged",
    "user-log-in",
    "aministrator",
    "ersthelfer",
    "keep-distance",
    "family-and-work",
    "elevator",
    "info-person",
    "man",
    "service-desk",
    "shower-men",
    "shower-women",
    "toilets",
    "wardrobe-men",
    "wardrobe-women",
    "wheelchair",
    "woman",
    "production-workers",
    "professionals-executives",
    "day-care",
    "hr-administration",
    "labor-relations",
    "offboarding",
    "pension",
    "personal-devolpement",
    "submitter-behavior",
    "vote",
    "administration-key-figures",
    "discussion",
    "discussion-voting",
    "personalized-driver-profile",
    "mentoring",
    "representative",
    "procom",
    "shared-services",
    "customer-service",
    "schwerbehindertenvertretung",
    "managing-director",
    "on-the-job",
    "user-access-error",
    "construction-site-playground",
    "family",
    "littering",
    "professionals-know-professionals",
    "efficiency",
    "administrator",
    "ear",
    "LLCT",
    "stamp-card",
    "employee-photos",
    "profile-change",
    "diversity",
    "employer-brand-film-sound",
    "talent-management",
    "fingerprint",
    "braille",
    "mental-disability",
    "visual-impairement",
    "accessibility",
    "youth-trainee-representation",
    "quality-management",
    "shared-service",
    "work-accident",
    "woman-at-liebherr",
    "be-liebherr-be-the-future"
  ],
  UI: [
    "invisible",
    "thumbs-down",
    "thumbs-up",
    "data-security",
    "digital-touch",
    "duplicate",
    "filter-reset",
    "arrow-down",
    "bin",
    "calender",
    "circle-arrow-right",
    "download",
    "filter-adjust",
    "info-circle",
    "info",
    "plus",
    "printer",
    "search",
    "user",
    "history",
    "upload-invitation-overview",
    "upload-invitation",
    "upload",
    "back-arrow-circle",
    "checkmark",
    "edit",
    "x",
    "envelope",
    "fax",
    "visible",
    "star-black",
    "star",
    "save",
    "favourites",
    "font-arrow",
    "menu",
    "phone",
    "app-launcher",
    "control-assistance-systems",
    "user-permission",
    "arrow-up",
    "arrow-down-1",
    "to-the-top",
    "slider-right",
    "menu-small",
    "user-logged",
    "user-log-in",
    "snapshot",
    "further-options-2",
    "aministrator",
    "slider-left",
    "move",
    "minus",
    "further-options-1",
    "font-arrow-left",
    "link-2",
    "circle-arrow-clockwise",
    "rss-feed-frame",
    "rss-feed",
    "star-plus",
    "entrance",
    "heart",
    "home-2",
    "map",
    "map-location",
    "share",
    "target",
    "wifi",
    "arrow-up-down",
    "at",
    "no-wifi",
    "compare",
    "confirmation",
    "compare-invert",
    "virtual-smartcard",
    "with-hand-to-wipe",
    "entire-gesture-control",
    "exit",
    "gearwheel",
    "globe",
    "arrow-right",
    "arrow-left",
    "unlink",
    "sort-arrow",
    "globe-reduced",
    "link",
    "status-message-inprogress-warning",
    "rfid",
    "font-arrow-up",
    "font-arrow-down",
    "not-found",
    "touch-display",
    "code-view",
    "share-2",
    "QR-code-2",
    "arrow-first-page",
    "arrow-last-page",
    "modular-system",
    "undo-1",
    "redo",
    "attachment",
    "further-options-4",
    "further-options-3",
    "contrast",
    "action-list",
    "circle",
    "AI-star",
    "import"
  ],
  SY: [
    "smiley-positiv",
    "thumbs-down",
    "thumbs-up",
    "error-rework",
    "filter-reset",
    "quote",
    "scissors",
    "smiley-negativ",
    "smiley-neutral",
    "calender",
    "info-circle",
    "info",
    "plus",
    "warning",
    "back-arrow-circle",
    "checkmark",
    "edit",
    "x",
    "volume",
    "volume-off",
    "star-black",
    "star",
    "my-notifier",
    "pause",
    "play",
    "settings",
    "stop",
    "projects",
    "triangle-with-exclamation-mark",
    "minus",
    "heart-black",
    "forbidden",
    "music",
    "circle-arrow-clockwise",
    "innovations",
    "star-plus",
    "heart",
    "question-mark",
    "confirmation",
    "hourglass",
    "filter",
    "clock",
    "sound-off",
    "gearwheel",
    "globe",
    "legal",
    "bonus-shop",
    "diameter",
    "key",
    "triangle",
    "timer",
    "warning-light",
    "turn-engine",
    "eraser",
    "umbrella",
    "euro",
    "flag",
    "flexibility",
    "attachment",
    "exclamation-mark",
    "simplify",
    "five-stars-filled",
    "five-stars",
    "chess",
    "trefoil",
    "box-two",
    "box-one",
    "box-three",
    "calculator",
    "pin",
    "pin-filled",
    "AER-unlock",
    "quality-management",
    "reflective-details",
    "two-in-one",
    "static-selector",
    "trolley",
    "travel-conveyor",
    "AI-star",
    "remote-access",
    "direct-current",
    "alternating-current"
  ],
  DO: [
    "special-leave",
    "survey",
    "application",
    "application-tips",
    "certificate",
    "checklist",
    "document1",
    "duplicate",
    "images",
    "inquiry-list",
    "offer",
    "calender",
    "document3",
    "history",
    "order-details",
    "product-catalog",
    "product-documents",
    "spare-parts-catalog",
    "inquiry",
    "poster",
    "lh-signal-info",
    "checklist-2",
    "commercial-education",
    "file",
    "news_2",
    "pay-slip-specification",
    "table",
    "electronic-invoice",
    "job-title",
    "evaluation-old-part",
    "invoice",
    "credit-card",
    "prepayment",
    "news",
    "document2",
    "paragraph",
    "public-transport-job-tickets",
    "brochures",
    "key-figures-library",
    "notebook",
    "problems",
    "questionaire",
    "reasons-for-rejection",
    "solutions",
    "survey-1",
    "tax",
    "vote",
    "tag",
    "2030",
    "ePricelist",
    "no-data",
    "download-document",
    "purchasing-portal",
    "norm-IEC-61010-2-011",
    "DIN-EN-60335",
    "DIN-EN-ISO-14644",
    "DIN-13277",
    "DIN-EN-16825-2015",
    "file-xls",
    "file-pdf",
    "general-package",
    "screenreader",
    "ip-management",
    "tasks",
    "agreements-instructions",
    "annual-calendar",
    "company-agreement",
    "newspaper",
    "SAL-specification-list",
    "training-catalogue",
    "sick-note",
    "archive",
    "energy-planner",
    "service-ticketing-system"
  ],
  EL: [
    "apple",
    "google",
    "microsoft",
    "instagram",
    "kununu",
    "linkedin",
    "twitter",
    "xing",
    "facebook",
    "youtube",
    "visa",
    "paypal",
    "sofort",
    "mastercard",
    "whatsapp",
    "paypal-2",
    "tiktok",
    "x-logo",
    "instagram-reel",
    "youtube-shorts",
    "snapchat",
    "meta",
    "wechat",
    "weibo",
    "pinterest",
    "houzz",
    "Xiaohongshu-red"
  ],
  EH: [
    "application",
    "application-tips",
    "area-of-application",
    "certificate",
    "employees",
    "entry-level",
    "further-education-funding",
    "unused-employee-potential",
    "brain",
    "classes",
    "e-learning",
    "employee-events",
    "employer-funded-pension",
    "flexible-working-hours",
    "gifts-for-employees",
    "target-group",
    "job-interview",
    "medal",
    "personnel-development",
    "commercial-education",
    "organization-chart",
    "qualifications",
    "additional-payment",
    "attractive-salary",
    "childcare",
    "family-and-work",
    "home-office",
    "initiative-application",
    "innovations",
    "jobcenter",
    "cardhouse",
    "employee-bicycles",
    "employer-funded-pension-2",
    "graduate",
    "day-care",
    "Goals-and-benefits",
    "participation",
    "talent",
    "administration-key-figures",
    "benefit-analysis",
    "career",
    "consolidate",
    "myOrganization",
    "procom",
    "shared-services",
    "family-and-work-2",
    "my-apprentice",
    "employer-funded-pension-dollar",
    "gantt",
    "risk-analysis",
    "milestone-plan",
    "talent-management",
    "expert-career",
    "youth-trainee-representation",
    "shared-service",
    "agreements-instructions",
    "company-agreement",
    "training-catalogue",
    "sick-note",
    "be-liebherr-be-the-future"
  ],
  CO: [
    "chat",
    "FAQ",
    "online-marketing",
    "send-message",
    "edit",
    "envelope",
    "billboard",
    "chat-cell-phone",
    "drone",
    "film",
    "phone-charger",
    "poster",
    "radio",
    "phone",
    "bluetooth",
    "microphone",
    "digital-signage",
    "HDR",
    "light-conditions",
    "electronic-invoice",
    "smart-camera",
    "language-of-job",
    "give-aways",
    "price-check",
    "discount",
    "invoice",
    "credit-card",
    "prepayment",
    "5G-antenne",
    "business-cell-phones",
    "initiative-application",
    "rss-feed-frame",
    "rss-feed",
    "satellite",
    "wifi",
    "app-android",
    "confirm-message",
    "envelope-open",
    "camera",
    "phoning-prohibited",
    "photography-prohibited",
    "discounts",
    "participation",
    "litab",
    "my-style",
    "app-ios",
    "notification",
    "no-notification",
    "window-management",
    "skyview",
    "innovation-management",
    "newspaper",
    "headphones",
    "celebration",
    "liebherr-chat",
    "service-ticketing-system",
    "translate"
  ],
  NS: [
    "eco",
    "cloud",
    "coolant",
    "leisure-offers",
    "resource-friendly",
    "sustainability",
    "wind-energy",
    "environmental-damage",
    "H2",
    "recycle",
    "recycle-with-text",
    "reduce",
    "reduce-with-text",
    "reuse",
    "reuse-with-text",
    "smart-farming",
    "alternative-fuels",
    "fire",
    "sun",
    "waves",
    "wind-energy-plant",
    "solar-panel",
    "drops",
    "do-not-use-in-case-of-fire",
    "LiGO",
    "CSR",
    "extreme-heat",
    "zero-emission-combustion-engines",
    "contains-fish-2",
    "pig",
    "littering",
    "hedgehog",
    "hippo",
    "horse",
    "monkey",
    "deer",
    "dog",
    "fox",
    "frog",
    "giraffe",
    "moon",
    "albatross",
    "coolant-2",
    "minerals1",
    "minerals2",
    "mine-rock",
    "ultra-efficient",
    "super-efficient",
    "humiditycontrol",
    "manual-defrost-start",
    "wind-speed",
    "feather",
    "horizon",
    "trefoil",
    "co2",
    "snail",
    "rabbit",
    "made-of-recycled-material",
    "application-severity",
    "hublebee"
  ],
  LWE: [
    "ballast-1",
    "ballast-2",
    "duty-cycle-crawler-crane-2",
    "extra-jib",
    "hook-height",
    "mobile-crane",
    "rotation",
    "telescopic-jib",
    "boom-configurations",
    "deep-foundation-1",
    "derrick-counterweight",
    "crane-finder",
    "petrochemical",
    "crane-load-capacity",
    "LICCON-Einsatzplaner",
    "telemetry",
    "crane-planner",
    "hook-position",
    "crane-climbing",
    "crane-telescopic-jib-max",
    "crane-folding-tip-max",
    "axle",
    "hook-max",
    "hook",
    "pulley-head-height",
    "mobile-crane-superstructure",
    "crawler-crane-superstructure",
    "main-boom-length",
    "main-boom-angle",
    "accessory-angle",
    "accessory-length",
    "boom-state",
    "cabin-position",
    "swing-axle",
    "slewing-range",
    "main-boom",
    "central-ballast",
    "side-inclination",
    "track-width",
    "ballast-radius",
    "supporting-base",
    "folding-jib",
    "electric-crane-operation",
    "driving-mode",
    "operation-mode",
    "mobile-crane-equipment",
    "box",
    "LWE",
    "YLWE"
  ],
  BF: [
    "bin",
    "printer",
    "fax",
    "phone",
    "AGG-Information",
    "lin",
    "smart-city",
    "house-search",
    "power-plant",
    "plug",
    "connected-fab",
    "display",
    "lighthouse",
    "crane-planner",
    "eiffel-tower",
    "company-apartments",
    "ergonomic-equipment",
    "pc",
    "home-2",
    "cleaning",
    "no-grid-access",
    "stairs",
    "technical-room",
    "video-surveillance",
    "wardrobe",
    "BMZ",
    "escalator",
    "floor",
    "lockers",
    "meeting-room",
    "office",
    "company",
    "press-area",
    "city",
    "key",
    "kitchen",
    "bookshelf",
    "notebook",
    "garage",
    "gate",
    "building-height",
    "building-distance",
    "washing-machine",
    "visitor-safety"
  ],
  LMT: [
    "concrete-pumps",
    "concrete-pumps-2",
    "concrete-technology",
    "mixing-plant-2",
    "mixing-plant",
    "conveyor-belt",
    "high-silo",
    "online-truck-mixer-configurators",
    "linfos-20",
    "concrete-telematics",
    "recycling-plants",
    "truck-mounted-pump-concrete-pressure",
    "concrete-technology-configurator",
    "twin-shaft-mixers",
    "volume-twin-shaft-mixers",
    "concrete-pump-delivery-rate",
    "filling-volume-ring-pan-mixer",
    "lrs-screw-diameter",
    "lrs-screw-length",
    "number-tower-silo",
    "output-capacity-m",
    "output-capacity-yd",
    "power-drive",
    "recycling-plant-LRT-trough-diameter",
    "recycling-plant-LRT-trough-length",
    "ring-pan-mixer",
    "ring-pan-mixer-rim-icon-rgb64px",
    "ring-pan-mixer-riv-d",
    "storage-volume-tower-silo-imperial",
    "storage-volume-tower-silo-metric",
    "truck-mounted-concrete-pump-horizontal-reach",
    "truck-mounted-concrete-pump-unfolding-height",
    "truck-mounted-concrete-pump-vertical-reach",
    "nominal-filling",
    "water-measure",
    "drum-capacity",
    "humidity-sensor",
    "CTPU",
    "BT"
  ],
  MCC: [
    "crane-BOS",
    "crane-CBB",
    "crane-LHM",
    "crane-LRS",
    "crane-MCR-main",
    "crane-STS",
    "reachstacker",
    "port-floating",
    "RMG",
    "RTG",
    "slew",
    "hoist",
    "MACR"
  ],
  LWN: [
    "crawler-crane-LWN",
    "deep-foundation",
    "deep-foundation-2",
    "duty-cycle-crawler-crane-2",
    "duty-cycle-crawler-crane",
    "my-jobsite",
    "deep-foundation-1",
    "derrick-counterweight",
    "subsoil-improvement",
    "drilling-depth",
    "drill-diameter",
    "slot-wall-gripper",
    "slot-wall-cutter",
    "LWE",
    "MCC"
  ],
  EMT: [
    "crawler-excavator",
    "telescope-loader",
    "duty-cycle-crawler-crane-2",
    "duty-cycle-crawler-crane",
    "crawler-tractor",
    "pipe-layer",
    "wheeled-excavator",
    "wheel-loader-big",
    "wheel-loader-small",
    "crawler-loader",
    "fuel-savings-calculator",
    "erc-system",
    "dump-truck",
    "care-packs",
    "railroad-excavator",
    "chains",
    "compactor",
    "drivers-cabin",
    "EMT",
    "MCC",
    "PE"
  ],
  LBC: [
    "fast-erecting-crane",
    "flat-top-crane",
    "high-top-crane",
    "hydraulic-fast-erecting-crane",
    "luffing-jib-crane",
    "mobile-construction-crane",
    "crane-configurator",
    "towercrane-portal",
    "tower-crane-repository",
    "tie-in-strut-calculator",
    "tower-cranes-max-capacity",
    "tower-cranes-max-radius",
    "tower-cranes-attr-height",
    "tower-cranes-attr-max-capacity",
    "tower-cranes-attr-radius",
    "hook",
    "TK10",
    "hook-carrier",
    "side-pull-control",
    "sway-control",
    "positioning-control",
    "TC",
    "MK"
  ],
  UST: [
    "material-handling-technology",
    "pedestal-material-handling-machine",
    "material-handling-technology-lh-c",
    "LH35M"
  ],
  MIN: [
    "mining-excavator",
    "mining",
    "mining-truck",
    "ponton-bagger",
    "fuel-extraction",
    "mining-truck-front-view",
    "mine",
    "mining-truck-drive-system",
    "minerals1",
    "minerals2",
    "mine-rock",
    "mine-owner",
    "mine-activity",
    "LMTD",
    "trolley-navigation-assist",
    "navigation-assist",
    "mining-dozer",
    "LPE-engine-control",
    "LPE-hydraulic-control",
    "bucket-filling-assistant",
    "application-severity",
    "mining-truck-loading-assistant",
    "MIN"
  ],
  MR: [
    "service-menu",
    "service",
    "service-partner",
    "predictive-maintenance",
    "weight",
    "engine-production",
    "lidia",
    "enginge-diagnostic",
    "double-gearwheel",
    "brushes",
    "plug",
    "torque",
    "alternative-fuels",
    "innovative-sealings",
    "special-fats",
    "crane-planner",
    "surface-treatment",
    "reparatur",
    "general-overhaul",
    "exchange-components",
    "evaluation-old-part",
    "axle-oils",
    "engine-oils",
    "fats",
    "gear-oils",
    "hydraulic-oils",
    "lubricants",
    "reman-programm",
    "screw-paste",
    "spray-hot-surfaces",
    "spray-hydraulic-cylinder",
    "spray",
    "wrench",
    "no-grid-access",
    "hydraulic-oils-low-temperature",
    "implementation-analysis",
    "innovation-pipeline",
    "double-gearwheel-checked",
    "double-gearwheel-crossed",
    "exhaust-after-treatment",
    "weighing-system",
    "reman",
    "partsXchanger",
    "customer-service",
    "xpert-assist",
    "statics-selector",
    "laboratory-trade",
    "hydraulikoel-druck",
    "tyres",
    "hydraulic-oil-pressure",
    "cutting-width",
    "anti-stick-slip",
    "corrision-control",
    "almost-maintenance-free",
    "brake",
    "steering-wheel",
    "fuel-cell",
    "oil",
    "hammer",
    "rope-lubrication",
    "inspection",
    "no-NOx",
    "digital-service-booklet",
    "quick-dry",
    "waterproof",
    "shock-absorber",
    "hot-area",
    "bio-hydraulic-oil",
    "food-grade-lubricant",
    "power-efficiency"
  ],
  AER: [
    "plane",
    "aerospace-transportation-system-2",
    "plane-take-off",
    "aerospace-transportation-system-1",
    "management-cockpit",
    "rack",
    "expertsmeeting",
    "AER-unlock",
    "eVTOL",
    "safety-management-system",
    "business-jet",
    "defense-aircraft",
    "flow",
    "AER-unlock",
    "regional-technical-workshop",
    "plane-chassis",
    "AER"
  ],
  TI: [
    "plane",
    "plane-take-off",
    "transport-logistics",
    "civil-construction",
    "damage",
    "tractor",
    "harvester",
    "rocket",
    "container-vessel",
    "monorail",
    "helicopter",
    "taxi",
    "train",
    "underground",
    "bike",
    "bus",
    "car",
    "delivery-truck",
    "load-securing",
    "turn-off-engines",
    "employee-bicycles",
    "public-transport-job-tickets",
    "shuttle-bus",
    "fuel-extraction",
    "electric-immobilizer",
    "petrol-pump",
    "special-vechicles",
    "agriculture-forestry",
    "building-construction-civil-engineering",
    "garbage-truck",
    "tunnel",
    "garage",
    "vehicle-fleet",
    "commercial-vehicle"
  ],
  HAU: [
    "refrigeration-freezing",
    "coolant",
    "cooling",
    "cleaning-freedom",
    "adjustable-feet",
    "bluRox",
    "specialized-trade",
    "kitchen",
    "laboratory-trade",
    "monolith",
    "mono",
    "chest-freezer",
    "wine-plus",
    "smamo",
    "freezer-bottom",
    "freezer",
    "frenchdoor",
    "HAU-integrated",
    "HAU-integrated-plus",
    "SBS",
    "top-freezer",
    "wine",
    "freestanding",
    "freestanding-plus",
    "my-style",
    "single-door",
    "fachhandel-plus",
    "coolant-2",
    "superfrost",
    "ultra-efficient",
    "recirculating-air-cooling",
    "supercool",
    "super-efficient",
    "retrofittable-wifi-lan-interface",
    "replaceable-door-seal",
    "power-outage-info",
    "refrigerant-r600a",
    "nofrost-technology",
    "norm-IEC-61010-2-011",
    "power-outage-alarm",
    "humiditycontrol",
    "integrated-data-logger",
    "integrierted-wifi-lan-interface",
    "lightalarm",
    "manual-defrost-start",
    "DIN-EN-60335",
    "DIN-EN-ISO-14644",
    "energylabel-EU-guideline-2015-1094",
    "feedthrough-for-external-sensors",
    "hidden-customer-menu",
    "DIN-13277",
    "DIN-EN-16825-2015",
    "10-years-componentdesign",
    "15-years-componentdesign",
    "alarmhistory",
    "alarmrelais",
    "alarm-test",
    "almost-maintenance-free",
    "atex-guideline",
    "demomodus",
    "smartfrost",
    "HNGRYnsite",
    "blurox",
    "fridge-consultant",
    "HOME"
  ],
  ABW: [
    "shackle",
    "sorting-grab",
    "stick-extension",
    "tiltrotator",
    "universal-bucket-wheel-loader",
    "wood-grab",
    "2-1-bucket",
    "4in1-bucket",
    "adapter-plate",
    "bucket",
    "bucket-telescopic-loader",
    "clamshell-grab",
    "dozer-blade",
    "dump-height-at-max-lift-height",
    "folding-shovel",
    "forklift",
    "grab-bucket-telescopic-loader",
    "grab-telescopic-loader",
    "hydraulic-manipulators",
    "light-material-bucket-wheel-loader",
    "LiTiU",
    "load-hook",
    "load-hook-telescopic-loader",
    "load-hook-wheel-loader",
    "log-grapple-wheel-loader",
    "magnet",
    "maximum-lifting-height",
    "maximum-load-capacity",
    "maximum-reach",
    "multi-tine-grab",
    "pallet-fork",
    "quick-coupler",
    "quick-coupler-MH",
    "quick-coupler-wheel-loader",
    "rock-shovel",
    "bucket-volume",
    "add-on-parts",
    "grab-volume-yd",
    "grab-volume-m",
    "grab-volume-m-yd",
    "grab-closing-force",
    "gripper",
    "kombi-greifer",
    "herzform-greifer",
    "hammer",
    "mill",
    "schnittbreite",
    "greifer-drehen",
    "inspect-multi-tine-grab",
    "pulverizers",
    "ripper-tooth",
    "scrap-shears",
    "shank-rippers",
    "stabilizer-blade",
    "suspension",
    "sweeper",
    "attachment-compactor",
    "covers",
    "equipment",
    "bucket-filling-assistant",
    "attachments",
    "liebher-attachment-assist-rgb-64px",
    "grading-beam"
  ],
  HS: [
    "health-activities",
    "virus-pathogen",
    "shaking-hands-prohibited",
    "care",
    "employer-funded-pension",
    "pharma",
    "visits-to-doctor-during-working-hours",
    "wash-your-hands",
    "WDS-eldercare",
    "BGM-Liebherr",
    "sport-1",
    "care-concept",
    "children-sick-pay",
    "sport-2",
    "sport-6",
    "sport-3",
    "sport-9",
    "sport-8",
    "sport-5",
    "sport-4",
    "sport-7",
    "maternity-protection",
    "everyday-mask",
    "desinfection",
    "ersthelfer",
    "heart-black",
    "keep-distance",
    "empowerment",
    "heart",
    "drops",
    "dosing",
    "employer-funded-pension-2",
    "smoking-prohibited",
    "day-care",
    "employer-funded-pension-dollar",
    "physician",
    "anti-bacterial",
    "braille",
    "mental-disability",
    "visual-impairement",
    "accessibility",
    "sports-group",
    "work-accident",
    "soap",
    "sick-note",
    "towel-dispenser",
    "hand-cream-dispenser"
  ],
  HOT: [
    "hotels"
  ],
  TE: [
    "workwear",
    "wardrobe-men",
    "wardrobe-women",
    "safety-shoes",
    "dresscode",
    "basecap",
    "highest-comfort",
    "breathable",
    "light-weight",
    "organic-cotton",
    "made-of-recycled-material",
    "reflective-details",
    "stretchable",
    "quick-dry",
    "waterproof",
    "two-in-one"
  ],
  LVT: [
    "gear-cutting-technology-automation",
    "PHS-Allround",
    "LVT",
    "LVT"
  ],
  SZ: [
    "font-arrow",
    "font-arrow-left",
    "at",
    "alpha-head-black",
    "alpha-text-bold",
    "alpha-text-regular",
    "numbered-list",
    "text-indent",
    "bold",
    "bulleted-list",
    "divider-line",
    "headline",
    "italic",
    "font-arrow-up",
    "font-arrow-down",
    "underline",
    "Aa",
    "align-center",
    "align-left",
    "align-right",
    "free-line"
  ],
  CA: [
    "bottle",
    "apple-core",
    "cocktail-glas-1",
    "cocktail-glass-2",
    "cocktail-glass-3",
    "cocktail-glass-4",
    "dinner",
    "cup",
    "gluten",
    "vegan",
    "gluten-free",
    "kitchen",
    "brezel",
    "spuelmaschinen-geeignet",
    "nicht-lebensmittelecht",
    "nicht-spuelmaschinen-geeignet",
    "lebensmittelecht",
    "wine",
    "ice-cream",
    "vegan-2",
    "vegetarian-2",
    "vegetarian",
    "contains-fish-2",
    "contains-fish",
    "contains-gluten-2",
    "contains-gluten",
    "gluten-free-2",
    "lactose-free-2",
    "lactose-free",
    "pig",
    "beer-mug",
    "beer-keg",
    "sandwich"
  ],
  GS: [
    "elevator",
    "entrance",
    "map",
    "map-location",
    "parking",
    "signpost",
    "target",
    "push",
    "smoking-prohibited",
    "stairs",
    "access-control",
    "bus-stop",
    "cafe-staff-only",
    "do-not-enter",
    "entry-staff-only",
    "escalator",
    "exit",
    "floor",
    "meeting-point",
    "orientation-system",
    "pedestrian-walkway",
    "phoning-prohibited",
    "photography-prohibited",
    "pull",
    "globe",
    "ground-floor",
    "upper-floor",
    "globe-reduced",
    "360",
    "zone",
    "navigation",
    "compass"
  ],
  EB: [
    "employer-brand-film-sound",
    "professional-methodological-competence",
    "leadership-competence"
  ],
  TS: [
    "high-voltage-pylon"
  ],
  COK: [
    "spare-parts-hydraulic-cylinders",
    "smart-hydraulic-cylinders"
  ]
}, N = {
  AER: "Aerospace und Verkehrstechnik",
  EMT: "Erdbewegung",
  EMS: "Energy storage and management",
  LMT: "Betontechnik",
  LWN: "Spezialtiefbau",
  LBC: "Turmdrehkrane",
  ABW: "Anbauwerkzeuge",
  HOT: "Hotels",
  COT: "Komponenten",
  HAU: "Kühlen und Gefrieren",
  MCC: "Maritime Krane",
  MIN: "Mining",
  LWE: "Mobil und Raupenkrane",
  UST: "Umschlagtechnik",
  LVT: "Verzahntechnik",
  BF: "Building and Facility",
  CA: "Catering",
  CO: "Communication",
  DS: "Digital Services and data security",
  DO: "Documents",
  EH: "Education and Human resources",
  EL: "External logos",
  GS: "Guidance Sytem",
  HS: "Health and sports",
  MR: "Maintenance and repair",
  NS: "Nature and sustainability",
  PE: "People",
  PL: "Production and logistics",
  SY: "Symbols",
  SZ: "Schriftzeichen",
  TI: "Transportation and Infrastructure",
  UI: "User interface"
}, H = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.absolute{position:absolute}.relative{position:relative}.right-\\[16px\\]{right:16px}.my-\\[8px\\]{margin-bottom:8px;margin-top:8px}.block{display:block}.inline-block{display:inline-block}.flex{display:flex}.hidden{display:none}.h-\\[48px\\]{height:48px}.h-full{height:100%}.h-\\[240px\\]{height:240px}.h-\\[17px\\]{height:17px}.h-\\[1px\\]{height:1px}.min-h-\\[48px\\]{min-height:48px}.w-full{width:100%}.flex-\\[1_0_auto\\]{flex:1 0 auto}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.flex-row{flex-direction:row}.flex-col{flex-direction:column}.overflow-y-hidden{overflow-y:hidden}.overflow-x-scroll{overflow-x:scroll}.overflow-y-scroll{overflow-y:scroll}.whitespace-nowrap{white-space:nowrap}.border-b{border-bottom-width:1px}.border-solid{border-style:solid}.bg-gray-100{background-color:var(--color-neutral-steel-100)}.px-\\[16px\\]{padding-right:16px}.pl-\\[16px\\],.px-\\[16px\\]{padding-left:16px}.font-text-bold{font-family:var(--copytext-font-family-bold)}.text-copy-extra-small{font-size:var(--copytext-font-size-extra-small)}.leading-\\[48px\\]{line-height:48px}.text-black{color:var(--color-black)}.container{display:block;height:100%;position:relative}input{background-color:var(--color-neutral-steel-100);outline:2px solid transparent;outline-offset:2px;padding-left:16px}input::-moz-placeholder{color:var(--color-neutral-steel-400);opacity:1}input::placeholder{color:var(--color-neutral-steel-400);opacity:1}input::-ms-input-placeholder{color:var(--color-neutral-steel-400)}.searchbox-container{border-bottom-color:var(--color-neutral-steel-400);border-bottom-width:1px;display:inline-block;height:var(--component-default-size);position:relative}.searchbox-container .clear-icon{align-items:center;cursor:pointer;display:flex;height:var(--component-default-size);position:absolute;right:16px;top:var(--spacing-0)}.searchbox-container .clear-icon patternlib-icon,.searchbox-container .clear-icon patternlib-icon-svg{margin-bottom:0}.category-and-icon-container{display:flex;flex-direction:column;height:100%}.category-container{background-color:var(--color-neutral-steel-100);display:flex;flex:1 0 auto;flex-direction:row;font-size:var(--copytext-font-size-extra-small);height:auto;overflow-x:scroll;overflow-y:hidden;position:relative;width:100%}.category-container .category{border-bottom-width:1px;border-color:var(--color-neutral-steel-400);border-style:solid;color:var(--color-neutral-steel-500);cursor:pointer;display:inline-block;font-family:var(--copytext-font-family-bold);height:48px;line-height:48px;padding-left:16px;padding-right:16px;-webkit-user-select:none;-moz-user-select:none;user-select:none;white-space:nowrap}.category-container .category.active{color:var(--color-black);font-family:var(--copytext-font-family-bold)}.left-gradient{left:var(--spacing-0);transform:rotate(-180deg)}.left-gradient,.right-gradient{background:linear-gradient(270deg,#f0f3f6,hsla(0,0%,100%,0));height:48px;position:absolute;top:48px;width:30px;z-index:0;z-index:10}.right-gradient{right:var(--spacing-0)}.icon-container{height:100%;overflow-x:hidden;overflow-y:scroll;padding:8px 16px;position:relative;width:100%}.search-icon-container{height:240px;padding:8px 16px;width:100%}.heading{align-items:center;display:flex;font-family:var(--copytext-font-family-bold);font-size:var(--copytext-font-size-small);min-height:48px;padding-bottom:var(--spacing-2);padding-top:var(--spacing-2)}patternlib-icon,patternlib-icon-svg{cursor:pointer;padding:12px}patternlib-icon-svg:hover,patternlib-icon:hover{background-color:var(--color-accent-clay-soft)}.separator{align-items:center;background-color:var(--color-neutral-steel-400);display:none;height:1px;margin-bottom:8px;margin-top:8px;width:100%}.hover\\:bg-clay-soft:hover{background-color:var(--color-accent-clay-soft)}@media (min-width:768px){.searchbox-container{border-bottom-color:var(--color-neutral-steel-400);border-bottom-width:1px}.category-and-icon-container{flex-direction:row}.category-container{background-color:var(--color-white);border-color:var(--color-neutral-steel-400);border-right-width:1px;display:block;overflow-x:hidden;overflow-y:auto;padding-bottom:8px;padding-top:8px;width:204px}.category-container .category{border-bottom-width:0;border-top-width:0;color:var(--color-black);font-family:var(--copytext-font-family);height:32px;line-height:32px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;width:180px}.search-icon-container{height:518px}.separator{display:flex}.tablet\\:block{display:block}.tablet\\:flex{display:flex}.tablet\\:h-\\[32px\\]{height:32px}.tablet\\:h-\\[518px\\]{height:518px}.tablet\\:w-\\[204px\\]{width:204px}.tablet\\:w-\\[180px\\]{width:180px}.tablet\\:flex-row{flex-direction:row}.tablet\\:overflow-x-hidden{overflow-x:hidden}.tablet\\:truncate{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.tablet\\:border-b{border-bottom-width:1px}.tablet\\:border-r{border-right-width:1px}.tablet\\:border-t-0{border-top-width:0}.tablet\\:bg-white{background-color:var(--color-white)}.tablet\\:py-\\[8px\\]{padding-bottom:8px;padding-top:8px}.tablet\\:font-text{font-family:var(--copytext-font-family)}.tablet\\:leading-\\[32px\\]{line-height:32px}.tablet\\:text-black{color:var(--color-black)}}.static{position:static}.mb-1{margin-bottom:var(--spacing-1)}.bg-primary{background-color:var(--color-brand-primary)}.font-text{font-family:var(--copytext-font-family)}.filter{filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}@media (min-width:768px){.tablet\\:hidden{display:none}}", O = H, j = class {
  constructor(o) {
    T(this, o), this.categorySelectEvent = b(this, "lhCategorySelect", 7), this.iconSelectEvent = b(this, "lhIconSelect", 7), this.handleSearch = (r, i) => {
      const c = r.toLowerCase(), p = {};
      return Object.keys(i).map((n) => {
        var d;
        (n.toLowerCase().includes(c) || !((d = this.mappings[n]) === null || d === void 0) && d.toLowerCase().includes(c)) && (p[n] = i[n]);
        const g = i[n].filter((m) => m.toLowerCase().includes(c));
        g.length > 0 && (p[n] = g);
      }), p;
    }, this.handleIconClick = (r) => (i) => {
      i.stopPropagation(), this.activeIcon = r, this.iconSelectEvent.emit({
        name: r
      });
    }, this.handleClearIconClick = () => {
      this.searchValue = "", this.filteredIcons = Object.assign({}, this.icons);
    }, this.handleInput = (r) => {
      const i = r.target;
      this.searchValue = i.value, this.filteredIcons = this.searchFunc(i.value, this.icons);
    }, this.handleSetActive = (r) => (i) => {
      i.stopPropagation(), this.categorySelectEvent.emit(r);
    }, this.icons = R, this.hideCategories = [], this.mappings = N, this.favorites = [], this.recentlyUsed = [], this.searchFunc = this.handleSearch.bind(this), this.activeCategory = void 0, this.searchInputPlaceholder = "Search Icons", this.filteredIcons = this.icons, this.searchValue = "", this.activeIcon = null;
  }
  onCategoryChange() {
    this.getCategoryIconsIntoView(this.activeCategory);
  }
  componentDidLoad() {
    this.getCategoryIconsIntoView(this.activeCategory);
  }
  /**
   * Private method to scroll a category and the belonged icons into view.
   * @param id of the icon category to show
   */
  getCategoryIconsIntoView(o) {
    if (o != null && o !== "") {
      const r = this.hostElement.shadowRoot.querySelector("#category-" + o);
      r != null && this.iconContainer.scrollTo({ top: r.offsetTop - 5, behavior: "smooth" });
    }
  }
  render() {
    var o, r;
    const i = {
      container: !0
    }, c = {
      "w-full font-text": !0,
      "searchbox-container": !0
    }, p = {
      "w-full": !0,
      "h-full": !0
    }, n = {
      "category-and-icon-container": !0
    }, d = {
      "category-container": !0
    }, g = {
      "icon-container": !0
    }, m = {
      "left-gradient": !0,
      "block tablet:hidden": !0
    }, y = {
      "right-gradient": !0,
      "block tablet:hidden": !0
    }, u = (t) => this.activeIcon === t, h = "32px", v = e("div", { class: c }, e("input", { onInput: this.handleInput, type: "text", name: "search", id: "search", placeholder: this.searchInputPlaceholder, class: p, value: this.searchValue }), this.searchValue !== "" && e("div", { class: "clear-icon", onClick: this.handleClearIconClick }, e("patternlib-icon", { size: h, "icon-name": "x" })), e(l, null, e("div", { class: m }), e("div", { class: y }))), w = e("div", { class: { category: !0, active: this.activeCategory === "favorites" }, onClick: this.handleSetActive("favorites") }, e("span", { id: "category-fav" }, e("slot", { name: "favoriteLabel" }, "Favorites"))), k = e(l, null, e("div", { class: { category: !0, active: this.activeCategory === "recently" }, onClick: this.handleSetActive("recently") }, e("span", { id: "category-rec" }, e("slot", { name: "recentlyLabel" }, "Recently used")))), x = Object.keys((o = this.filteredIcons) !== null && o !== void 0 ? o : {}).filter((t) => !this.hideCategories.includes(t)).map((t) => {
      var a, s;
      return e("div", { class: { category: !0, active: this.activeCategory === t }, onClick: this.handleSetActive(t) }, (s = (a = this.mappings) === null || a === void 0 ? void 0 : a[t]) !== null && s !== void 0 ? s : t);
    }), C = e(l, null, e("div", { class: "heading" }, e("p", { id: "category-favorites" }, e("slot", { name: "favoriteLabel" }, "Favorites"))), e("span", { class: "block mb-1" }, this.favorites.map((t) => e("patternlib-icon", { size: h, iconName: t, display: "inline-block", class: { "bg-primary": u(t) }, onClick: this.handleIconClick(t) })))), I = e(l, null, e("div", { class: "heading" }, e("p", { id: "category-recently" }, e("slot", { name: "recentlyLabel" }, "Recently used"))), e("span", { class: "block mb-1" }, this.recentlyUsed.map((t) => e("patternlib-icon", { size: h, display: "inline-block", iconName: t, class: { "bg-primary": u(t) }, onClick: this.handleIconClick(t) })))), S = () => {
      const t = Array.from(new Set(Object.values(this.filteredIcons).flatMap((a) => a)));
      return e("div", { class: "block mb-1" }, e("div", { class: "heading" }, " ", e("slot", { name: "searchResultLabel" }, "Search results")), t.map((a) => e("patternlib-icon", { size: h, iconName: a, display: "inline-block", class: { "bg-primary": u(a) }, onClick: this.handleIconClick(a) })));
    }, E = Object.keys((r = this.filteredIcons) !== null && r !== void 0 ? r : {}).filter((t) => !this.hideCategories.includes(t)).map((t) => {
      var a, s;
      return e(l, null, e("div", { class: "heading" }, e("p", { id: "category-" + t }, (s = (a = this.mappings) === null || a === void 0 ? void 0 : a[t]) !== null && s !== void 0 ? s : t)), e("span", { class: "block mb-1" }, this.filteredIcons[t].map((f) => e("patternlib-icon", { iconName: f, display: "inline-block", size: h, class: { "bg-primary": u(f) }, onClick: this.handleIconClick(f) }))));
    }), L = (
      // container for categories
      e("div", { class: d }, !this.hideCategories.includes("FAVORITES") && w, !this.hideCategories.includes("RECENTLY_USED") && k, e("span", { class: "separator" }), x)
    ), z = (
      // container for icons
      e("div", { class: g, ref: (t) => this.iconContainer = t }, (this.searchValue == null || this.searchValue === "") && !this.hideCategories.includes("FAVORITES") && C, (this.searchValue == null || this.searchValue === "") && !this.hideCategories.includes("RECENTLY_USED") && I, this.searchValue === "" ? E : S())
    );
    return e(A, null, e("div", { class: i }, v, e("div", { class: n }, e(l, null, (this.searchValue == null || this.searchValue === "") && L, z))));
  }
  get hostElement() {
    return M(this);
  }
  static get watchers() {
    return {
      activeCategory: ["onCategoryChange"]
    };
  }
};
j.style = O;
export {
  j as patternlib_iconpicker
};
